import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '@Common/PageBuilder/components/FormField/abstract-form-field.component';
import { DisplayElementModel } from '@Common/PageBuilder/models/display-element.model';
import { ColorPickerFieldModel } from '@Common/PageBuilder/models/color-picker-field.model';
import { FormFieldModel } from './form-field.model';

export function buttonBackgroundColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'buttonBackgroundColor',
        key: 'buttonBackgroundColor',
        icon: 'fa-regular fa-duotone fa-fill-drip',
        tooltip: 'PageBuilder.formField.tooltip.buttonBackgroundColor',
        showRecentColors
    };
};

export function borderConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'borderColor',
        icon: 'fa-regular fa-duotone fa-fill-drip',
        tooltip: 'PageBuilder.formField.tooltip.buttonBackgroundColor',
        showRecentColors
    };
};


export function buttonColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'buttonColor',
        key: 'buttonColor',
        icon: 'fa-regular fa-duotone fa-paintbrush',
        tooltip: 'PageBuilder.formField.tooltip.buttonColor',
        showRecentColors
    };
};

export function fontColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'fontColor',
        key: 'fontColor',
        icon: 'agpr-i-font-color',
        tooltip: 'PageBuilder.formField.tooltip.fontColor',
        showRecentColors
    };
};


export function dividerColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'dividerColor',
        icon: 'fa-regular fa-duotone fa-paintbrush',
        showRecentColors
    };
};


export function backgroundColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'backgroundColor',
        icon: 'fa-regular fa-duotone fa-fill-drip',
        tooltip: 'PageBuilder.formField.tooltip.backgroundColor',
        showRecentColors
    };

};

export function textColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'color',
        key:  'color',
        icon: 'agpr-i-font-color',
        tooltip: 'PageBuilder.formField.tooltip.fontColor',
        showRecentColors
    };
};


export function captionTextColorConfig( showRecentColors = false): AdvancedColorPickerConfig {
    return {
        ...textColorConfig(showRecentColors),
        key: '',
        tooltip: 'PageBuilder.formField.tooltip.captionColor',
    };
};

export function iconBackgroundColorConfig(showRecentColors = false): AdvancedColorPickerConfig {
    return {
        property: 'iconBackgroundColor',
        icon: 'fa-regular fa-duotone fa-fill-drip',
        tooltip: 'PageBuilder.formField.tooltip.iconBackgroundColor',
        showRecentColors
    };
};


type ColorPickerPartial = Partial<ColorPickerFieldModel>;

export interface AdvancedColorPickerConfig extends ColorPickerPartial {
    initialValue?: string;
    disabled?: boolean;
    showDeleteButton?: boolean;
    icon?: string;
    showRecentColors?: boolean;
    label?: string;
    tooltip?: string;
    tooltipPosition?: string;
    ariaLabel?: string;
    doBorder?: boolean;
    key?: string;
    property?: string;
    initSelection?: boolean;
    showFavoriteColors?: boolean;
    appearCondition?: (displayElement: DisplayElementModel | any) => boolean;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    applyHueChange?: boolean;
}


export class AdvancedColorPickerFieldModel implements FormFieldModel {
    initialValue: string = '';
    disabled: boolean = false;
    showDeleteButton: boolean = false;
    icon: string = '';
    showRecentColors: boolean = false;
    label = '';
    tooltip: string = '';
    tooltipPosition: string = 'right';
    ariaLabel?: string = '';
    doBorder?: boolean = false;
    key: string = '';
    property: string = '';
    initSelection: boolean = false;
    showFavoriteColors: boolean = true;
    inline = false;
    applyHueChange = true;
    appearCondition?: (displayElement: DisplayElementModel | any) => boolean;
    fieldComponent?: Type<AbstractFormFieldComponent>;

    protected constructor(config?: AdvancedColorPickerConfig) {
        Object.assign(this, config); // preserve defaults
    }

    public static create(config?: AdvancedColorPickerConfig) {
        return new AdvancedColorPickerFieldModel(config);
    }

}
